import { useCallback } from "react";
import {
  IUserSeenModalPayload,
  IUserSeenModalResponse,
  CorpSessionInfo,
  SessionInfo,
  ModalName,
} from "redmond";
import { updateUserSeenModal } from "../api/v1/user/updateUserSeenModal";

export const useSeenModalUpdater = (
  sessionInfo: SessionInfo | CorpSessionInfo | undefined,
  setSessionInfo: React.Dispatch<
    React.SetStateAction<SessionInfo | CorpSessionInfo | undefined>
  >
) => {
  const handleSeenModal = useCallback(
    (body: IUserSeenModalPayload): Promise<IUserSeenModalResponse> =>
      new Promise((resolve, reject) => {
        updateUserSeenModal(body)
          .then((response) => {
            setSessionInfo((prevSessionInfo) => {
              if (!prevSessionInfo || !("corporateInfo" in prevSessionInfo)) {
                return prevSessionInfo;
              }

              const updatedSessionInfo = {
                ...prevSessionInfo,
              } as CorpSessionInfo;

              if (!updatedSessionInfo.corporateInfo.hasSeenModalMap) {
                updatedSessionInfo.corporateInfo.hasSeenModalMap = {} as Record<
                  ModalName,
                  boolean
                >;
              }

              updatedSessionInfo.corporateInfo.hasSeenModalMap[body.modalName] =
                true;

              return updatedSessionInfo;
            });
            resolve(response);
          })
          .catch((error) => {
            console.error("Error updating user seen modal:", error);
            reject(error);
          });
      }),
    [sessionInfo, setSessionInfo]
  );

  return handleSeenModal;
};
